export const COMMENT = 'comment';
export const REPLY = 'reply';
